var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
var FormControl_1 = __importDefault(require("./FormControl"));
exports.FormControl = FormControl_1.default;
exports.default = FormControl_1.default;
//# sourceMappingURL=index.js.map